import baseService from '../utils/axios';
import {UUID} from "../interfaces/general";
import {VennieProcessingComment} from "../interfaces/processing";

export const getProcessingLogs = async (
  page: number,
  pageSize: number,
  onlyBugs: boolean = false,
  onlyAutoTests: boolean = false
) => baseService.get(
  '/processing_log/account_logs',
  { params:{ page: page, page_size: pageSize, only_bugs: onlyBugs, only_auto_tests: onlyAutoTests}}
);

export const findLogByTicketId = async (ticketId: string) => baseService.get(
  `/processing_log/ticket_log/${ticketId}`
);

export const getLogById = async (logId: string) => baseService.get(
  `/processing_log/log/${logId}`,
);

export const getProcessingEntry = async (logId: string, userId: UUID | null | undefined) => baseService.get(
  `/processing_log/processing_entry/${logId}`,
  { params: { user_id: userId } }
);

export const getProcessingRuns = async (logId: string, userId: UUID | null | undefined) => baseService.get(
  `/processing_log/processing_runs/${logId}`,
  { params: { user_id: userId } }
);

export const getProcessingRun = async (runId: string) => baseService.get(
  `/processing_log/processing_run/${runId}`,
);

export const updateProcessingEntryComments = async (
  entryId: UUID,
  comments: Array<VennieProcessingComment>
) => baseService.post(
  `/processing_log/add_vennie_comment/${entryId}`,
  {comments}
);

export const setTicketAsBug = async (entryId: UUID, isBug: boolean) => baseService.post(
  `/processing_log/set_is_bug`,
  {
    processing_id: entryId,
    is_bug: isBug
  }
);

export const setLogBugSeverity = async (ticketLogId: UUID, severity: number) => baseService.post(
  `/processing_log/set_bug_severity`,
  {
    ticket_log_id: ticketLogId,
    bug_severity: severity
  }
);

export const setLogReadyForTesting = async (ticketLogId: UUID, isReady: boolean) => baseService.post(
  `/processing_log/set_bug_ready_testing`,
  {
    ticket_log_id: ticketLogId,
    is_bug_testing: isReady
  }
);

export const verifyReplaceImages = async (
  entryId: UUID,
  externalId: string,
  isVerified: boolean,
  isTest: boolean,
) => baseService.post(
  `/processing_log/set_replace_item_image_verify`,
  {
    processing_entry_id: entryId,
    external_id: externalId,
    is_approved: isVerified,
    is_test: isTest,
  }
);

export const createLogEntry = async (externalTicketId: string, ticketType: string, ticketStatus: string) => {
  return await baseService.post(`/processing_log/create_log_entry`, {
    external_ticket_id: externalTicketId,
    ticket_type: ticketType,
    ticket_status: ticketStatus
  });
};

export const createProcessingEntry = async (logId: UUID, externalTicketId: UUID) => {
  return await baseService.post(`/processing_log/create_processing_entry`, {
    ticket_log_id: logId,
    external_ticket_id: externalTicketId
  });
};

export const reportWrong = async (
  linkType: string,
  processingEntryId: UUID,
  answerActionId: UUID,
  comment: string
) => {
  return await baseService.post(`/processing_log/report_wrong`, {
    link_type: linkType,
    processing_entry_id: processingEntryId,
    answer_action_id: answerActionId,
    comment: comment
  });
};

export const getUnprocessedLogs = async (page: number = 1, pageSize: number = 100) => {
  return await baseService.get(`/processing_log/unprocessed_logs`, {
    params: {
      page,
      page_size: pageSize
    }
  });
};

export const postRerunTicketLog = async (ticketLogId: string, isTest: boolean) => {
  return await baseService.post(`/processing_log/rerun_ticket_log`, {
    ticket_log_id: ticketLogId,
    is_test: isTest
  });
};

export const getOldestLogs = async (limit: number) => {
  return await baseService.get(`/processing_log/oldest_logs`, {
    params: {
      limit
    }
  });
};

export const deleteOldestLogs = async (limit: number = 100) => {
  return await baseService.post(`/processing_log/delete_oldest_logs`, {
    limit
  });
};

export const getAllLogs = async (page: number = 1, pageSize: number = 100) => {
  return await baseService.get(`/processing_log/all_logs`, {
    params: {
      page,
      page_size: pageSize
    }
  });
};

export const getAccountLogsRuns = async (page: number = 1, pageSize: number = 100) => {
  return await baseService.get(`/processing_log/account_logs_runs`, {
    params: {
      page,
      page_size: pageSize
    }
  });
};

